var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "box",
    d: "M9.28889 16.1333L17.9056 7.51667L16.1944 5.80556L9.28889 12.7111L5.80556 9.22778L4.09444 10.9389L9.28889 16.1333ZM2.44444 22C1.77222 22 1.19656 21.7609 0.717444 21.2826C0.239148 20.8034 0 20.2278 0 19.5556V2.44444C0 1.77222 0.239148 1.19656 0.717444 0.717444C1.19656 0.239148 1.77222 0 2.44444 0H19.5556C20.2278 0 20.8034 0.239148 21.2826 0.717444C21.7609 1.19656 22 1.77222 22 2.44444V19.5556C22 20.2278 21.7609 20.8034 21.2826 21.2826C20.8034 21.7609 20.2278 22 19.5556 22H2.44444Z",
    fill: "#C4CDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBtnIcon);
export default __webpack_public_path__ + "static/media/checkBtnIcon.5702d658f9a8d691341a71425f676e22.svg";
export { ForwardRef as ReactComponent };